module.exports = __webpack_public_path__ + "static/media/2.f830efd8.svg";